import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ForgotUsernameService } from '../../shared/services/forget-user.service';
import { requestforgetUsernamePayload } from '../../shared/models/model';
import config from '../../../assets/config.json';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-forget-user',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './forget-user.component.html',
  styleUrl: './forget-user.component.scss',
})
export class ForgetUserComponent implements OnInit, AfterViewInit, OnDestroy {
  forgotUserNameForm!: FormGroup;
  isValid: boolean = true;
  isRecaptchaSel: boolean = false;
  isSuccessful: boolean = true;
  token: string = '';

  // ReCaptcha site key
  private siteKey: string = config.recaptchaKey;
  private reCaptchaapiUrl: string = config.reCaptchaapiUrl;
  forGetUserNamesubscription: Subscription = new Subscription();
  constructor(
    /* eslint-disable no-unused-vars */
    @Inject(PLATFORM_ID) private platformId: Object,
    private _http: HttpClient,
    private _router: Router,
    private _forgetUser: ForgotUsernameService,
    private _renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const siteKey = this.siteKey;
      /* eslint-disable no-undef */
      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.enterprise.render('recaptcha-container', {
          sitekey: siteKey,
          callback: this.onCaptchaResolved.bind(this),
        });
      } else {
        const recaptchaContainer = document.getElementById('recaptcha-container');
        if (recaptchaContainer) {
          this._renderer.setProperty(
            recaptchaContainer,
            'innerHTML',
            "<p class='recaptcha-error'>reCAPTCHA is not available.</p>",
          );
        }
      }
    }
    setTimeout(() => {
      const el = document.getElementById('g-recaptcha-response');
      if (el) {
        el.setAttribute('aria-label', 'reCAPTCHA');
      }
    }, 2000); // delay to allow Google to inject it
  }

  onCaptchaResolved(response: string): void {
    const apikey = config.reCaptchaApiKey;
    const url = this.reCaptchaapiUrl + apikey;
    this.token = response; // Store the reCAPTCHA token
    const body = {
      event: {
        token: response, // Your client-side reCAPTCHA token
        siteKey: this.siteKey, // Replace with your actual site key
        expectedAction: 'submit_form', // Replace with your expected action
      },
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    this.isRecaptchaSel = false; // Reset the flag when reCAPTCHA is resolved
    /* eslint-disable no-unused-vars */
    this._http.post<{ token: string }>(url, body, { headers: headers }).subscribe((response) => {});
  }

  ngOnInit(): void {
    // Initialize forget username form
    this.forgotUserNameForm = new FormGroup({
      emailAddress: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  // Navigate to sign-in page
  backToSignin() {
    this._router.navigate(['/login']);
  }

  validateInput(event: any): void {
    const inputValue = event.target.value;
    this.validateEmail(inputValue);
  }

  // Submit the form
  onSubmit() {
    if (!this.validateEmail(this.forgotUserNameForm.value.emailAddress)) {
      this.isValid = false;
      Object.values(this.forgotUserNameForm.controls).forEach((control) => control.markAsTouched());

      setTimeout(() => {
        const firstInvalidControl = document.querySelector('.is-required.ng-invalid');
        if (firstInvalidControl) {
          (firstInvalidControl as HTMLElement).focus();
        }
      }, 100);
    } else if (!this.token) {
      this.isRecaptchaSel = true;
    } else {
      this.forgotUserNameForm.markAllAsTouched();
      // API call to send email
      const emailAddr = this.forgotUserNameForm.value.emailAddress;
      const payload: requestforgetUsernamePayload = {
        requestingSystem: 'FinPro',
        emailAddress: emailAddr,
      };
      this.forGetUserNamesubscription = this._forgetUser.ForgetUserName(payload).subscribe((response) => {
        if (response && response.responseCode !== 200) {
          this._router.navigate(['/user-profile/call-us']);
          this.isSuccessful = true;
        } else {
          this.isSuccessful = false;
        }
      });
    }
  }

  // Validate email address
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@trustage\.com$/;
    const valid = emailRegex.test(email);
    if (valid) {
      this.isValid = true;
    }
    return valid;
  }

  // Continue to login page
  onContinue() {
    this.backToSignin();
  }
  ngOnDestroy(): void {
    // Unsubscribe from all
    this.forGetUserNamesubscription.unsubscribe();
  }
}
